export default __webpack_public_path__ + "static/media/grain.e7b40507.png";